import { BEAUTY_CATEGORIES } from '../../../../constants/constants';

export const INTEGRATION_PROVIDER = 'DaySmart';
export const INTEGRATION_PROVIDER_SERVICE_TYPE = 'Merchant';
export const ACCOUNT_ID_KEY = 'daysmart_acc';
export const DEFAULT_SERVICE_DATA = {};
export const DAYSMART_CATEGORIES_TO_ENABLE_INTEGRATION = BEAUTY_CATEGORIES;
